export default "__VITE_ASSET__425dce8a__"